import React from 'react'

import { useParams } from 'react-router-dom'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'

import { NcForm } from './components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'

const NcShow = () => {
  const { monitoringManagementNcId } = useParams()

  const { response, isLoading } = useFetch(
    service.dponet.monitoringManagementNc.show,
    { monitoringManagementNcId },
    [monitoringManagementNcId],
  )

  const monitoringManagementNc = response?.data?.monitoringManagementNc

  return (
    <Page title="Visualização de NC - Monitoramento">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Não Conformidade (NC)" />
        {!isLoading && (
          <NcForm monitoringManagementNc={monitoringManagementNc} isShow />
        )}
      </Container>
    </Page>
  )
}

export default NcShow
